import { get, post, put, patch } from "../../../services/api/Config"

const _api_route = `sustainability-performance`

// ========== Detail Page ========== //
export function SearchContent({ params = {}, lang }) {
  return get({ url: `/v1/admin/${_api_route}`, params, lang })
}
export function GetContentById({ id, lang }) {
  return get({ url: `/v1/admin/${_api_route}/${id}`, lang })
}
export function CreateContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}`, params, data, lang })
}
export function UpdateContent({ params = {}, data = {} , id, lang }) {
  return put({ url: `/v1/admin/${_api_route}/${id}`, params, data, lang })
}
export function PatchContent({ params = {}, data = {} , id, lang }) {
  return patch({ url: `/v1/admin/${_api_route}/${id}`, params, data, lang })
}
export function DeleteContent({ params = {}, data = {}, lang }) {
  return post({ url: `/v1/admin/${_api_route}/mutiDelete`, params, data, lang })
}
